import React, { useEffect, useState, useContext } from "react"
import { withFormik, Form, Field } from "formik"
import gql from "graphql-tag"
import * as Yup from "yup"
import { LangContext } from "../../../context/LangContext"
import { useMutation } from "@apollo/react-hooks"
import { submitUtm, extractCookie } from "../../../utils/handle-utm"

const importNumberForm = () => import("react-number-format")

const SUBMIT_EXLUSIVE_DEALS = gql`
  mutation SubmitFormExclusiveDeals(
    $fullName: String
    $email: String
    $phoneNumber: String
    $utm: String
    $propertyName: String
    $projectsCode: String
    $clusterCode: String
    $source: String
  ) {
    submit2FormExclusiveDeals(
      input: {
        clientMutationId: ""
        fullName: $fullName
        email: $email
        phoneNumber: $phoneNumber
        utm: $utm
        propertyName: $propertyName, 
        projectsCode: $projectsCode, 
        clusterCode: $clusterCode, 
        source: $source
      }
    ) {
      status
      message
    }
  }
`

export const GetMoreInfoForm = (
  {
    propertyName = '', 
    clusterCode = '', 
    leadSourceName = '', 
    projectsCode = '', 
    onSuccess
  }
) => {
  const { lang } = useContext(LangContext)
  const [formValues, setFormValues] = useState({
    name: "",
    email: "",
    phoneNumber: "",
  })
  const [submitForm, { loading }] = useMutation(SUBMIT_EXLUSIVE_DEALS)

  const sendForm = (formValues) => {
    const formatNumber = formValues.phoneNumber.split("+").join("")
    submitForm({
      variables: {
        fullName: formValues.name,
        email: formValues.email,
        phoneNumber: formatNumber,
        utm: extractCookie("utm_params=")
          ? JSON.stringify(extractCookie("utm_params="))
          : null,
        propertyName: propertyName, 
        projectsCode: projectsCode, 
        clusterCode: clusterCode, 
        source: "Info Produk"
      },
    }).then(res => {
      if (res.data.submit2FormExclusiveDeals.status === "success") {
        submitUtm({
          fullname: formValues.name,
          email: formValues.email,
          mobile: formValues.phoneNumber,
          project_name: propertyName,
          projects_code: projectsCode,
          cluster_code: clusterCode,
          lead_source_name: leadSourceName,
          web: "bsdcity.com",
        })
        onSuccess(formValues)
      }
    }).finally(() => {
      setFormValues({
        name: "",
        email: "",
        phoneNumber: "",
      })
    })
  }

  const [NumberFormat, setNumberFormat] = useState()

  useEffect(() => {
    importNumberForm().then(component => setNumberFormat(component))
  }, [])

  const NFComponent = NumberFormat && NumberFormat.default

  function validateEmail(value) {
    let error
    if (!value) {
      error = "Required"
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
      error = "Invalid email address"
    }
    return error
  }

  const LeadForm = ({ errors, touched, values, setFieldValue, btnLoading }) => {
    const phoneNumberHandler = (val, setFieldValue) =>
      setFieldValue("phoneNumber", val)

    return (
      <Form>
        <div className="form-group">
          <label className="my-0">
            {lang === "EN" ? "Your Name" : "Nama Anda"}
          </label>
          <Field
            name="name"
            className="form-control"
            placeholder={
              lang == "EN" ? "Enter your name" : "Masukkan nama kamu"
            }
            type="text"
          />
          {touched.name && errors.name && (
            <div className="invalid-value d-block">{errors.name}</div>
          )}
        </div>
        <div className="form-group">
          <label className="my-0">
            {lang === "EN" ? "Your Email" : "Email Anda"}
          </label>
          <Field
            name="email"
            className="form-control"
            placeholder={
              lang == "EN" ? "Enter your email" : "Masukkan email kamu"
            }
            type="text"
            validate={validateEmail}
          />
          {touched.email && errors.email && (
            <div className="invalid-value d-block">{errors.email}</div>
          )}
        </div>

        {NFComponent && (
          <div className="form-group">
            <label className="my-0">
              {lang === "EN" ? "Phone Number" : "Nomor Telepon"}
            </label>
            <NFComponent
              name="phoneNumber"
              className="form-control"
              placeholder={
                lang == "EN"
                  ? "Enter your phone number"
                  : "Masukkan nomor telepon"
              }
              allowEmptyFormatting
              prefix="+62"
              value={values.phoneNumber}
              onValueChange={val =>
                phoneNumberHandler(val.formattedValue, setFieldValue)
              }
            />
            {touched.phoneNumber && errors.phoneNumber && (
              <div className="invalid-value d-block">{errors.phoneNumber}</div>
            )}
          </div>
        )}

        <div className="form-group">
          <div className="d-flex flex-row align-items-center">
            <Field type="checkbox" name="agreement" />
            <span className="agreement ml-2">
              <a href="/privacy-policy/" target="_blank">
                {lang === "EN"
                  ? "I agree to the terms and conditions that apply.*"
                  : "Saya setuju dengan syarat & ketentuan yang berlaku.*"}
              </a>
            </span>
          </div>
          {touched.agreement && errors.agreement && (
            <div className="invalid-value d-block">{errors.agreement}</div>
          )}
        </div>

        <div className="form-group">
          <button className="btn btn-secondary btn-block">
            {btnLoading ? (
              <i className="fa fa-spinner fa-spin"></i>
            ) : (
              <>
                {lang == "EN" ? "Submit" : "Kirim"}{" "}
                <i className="fas fa-arrow-right ml-1"></i>{" "}
              </>
            )}
          </button>
          <p className="pt-3 text-muted">
            {lang == "EN"
              ? "BSD City will never sell or share your information with a third party"
              : "BSD City tidak akan pernah menjual atau membagikan informasi Anda kepada pihak ketiga"}
          </p>
        </div>
      </Form>
    )
  }

  const EnhancedLeadForm = withFormik({
    mapPropsToValues({ name, phoneNumber, email, agreement }) {
      return {
        name: name || formValues.name,
        email: email || formValues.email,
        phoneNumber: phoneNumber || formValues.phoneNumber,
        agreement: agreement || formValues.agreement,
      }
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required(
        `${lang == "EN" ? "Name is required" : "Nama harus di isi"}`
      ),
      email: Yup.string().required(
        `${lang == "EN" ? "Email is required" : "Email harus di isi"}`
      ),
      phoneNumber: Yup.string().required(
        `${
          lang == "EN"
            ? "Phone number is required"
            : "Nomor telepon harus di isi"
        }`
      ),
      agreement: Yup.boolean()
        .oneOf(
          [true],
          `${lang == "EN" ? "Agreement is required" : "Agreement harus di isi"}`
        )
        .required(
          `${lang == "EN" ? "Agreement is required" : "Agreement harus di isi"}`
        ),
    }),
    handleSubmit(values) {
      sendForm(values)
    },
  })(LeadForm)


  return (
    <>
      {NFComponent && <EnhancedLeadForm btnLoading={loading} />}
    </>
  )
}
